export default __webpack_public_path__ + "static/media/group-631.90eb3e5b.png";